"use strict";
exports.__esModule = true;
function resolveUrl() {
    return typeof window !== 'undefined' ? window.URL : require('url').URL;
}
exports["default"] = resolveUrl;
